import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  SourcesOfIncomeFormType,
  FormErrors,
  getSchema,
} from '../../forms/sourcesOfIncomeForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: SourcesOfIncomeFormType;
  onSubmit: (values: SourcesOfIncomeFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  subTitle?: string;
}

export const SourcesOfIncome = ({
  initialValues,
  canGoBack,
  submitLoading,
  formError,
  onGoBack,
  onSubmit,
  submitDisabled,
  subTitle,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t);
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={subTitle ?? t('onboarding.legalClientSourcesOfIncome.subtitle')}
      title={t('onboarding.legalClientSourcesOfIncome.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Stack spacing={32}>
        <FormContent {...formProps} />
      </Stack>
    </FormContainer>
  );
};
